// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__33BhD","check":"checkbox_check__80bCz","checked":"checkbox_checked__rkcut","container":"checkbox_container__2_n3u"};